<template>
    <div id="sjjEditor" style="padding-left: 10px;padding-right: 10px;height: 100%">
        <!-- 重命名 -->
        <el-dialog :close-on-click-modal="false" :visible.sync="renameDialog" title="重命名" width="550px">
            <!-- 字符串格式化 -->
            <el-form>
                <el-form-item label="新名称：">
                    <el-input type="text" v-model="rename" style="width: 400px;" size="medium"></el-input>
                </el-form-item>
            </el-form>
            <el-row style="margin-top: 10px">
                <el-button style="float: right" type="primary" size="small" @click="commitRename">确认</el-button>
                <el-button style="float: right;margin-right: 10px" type="primary" size="small" @click="renameDialog = false">关闭</el-button>
            </el-row>
        </el-dialog>
        <!-- 计算字段新增/编辑框 -->
        <el-dialog :close-on-click-modal="false" :visible.sync="dialogShow" :title="dialogTitle" width="900px" top="2%">
            <div style="height: 650px">
                <div style="width: 50%;height:100%;" class="inline">
                    <el-form label-width="100px" label-position="left">
                        <!-- 字段名 -->
                        <el-form-item label="字段名：" required>
                            <el-input v-model="computedField.fieldAlias" @input="fieldNameInputCheck" size="small" :clearable="true" style="width: 300px" maxlength="30"></el-input>
                        </el-form-item>
                        <!-- 计算表达式 -->
                        <el-form-item prop="expression" label="计算表达式：" required>
                            <custom-coder style="width: 300px;height: 200px" :code.sync="computedField.expression" :custom-auto-complete="computeFieldAutoComplete"></custom-coder>
                            <div class="myTips">按 ‘{’ 或 alt 可呼出可用字段</div>
                        </el-form-item>
                        <!-- 类型 -->
                        <el-form-item prop="dataType" label="类型：" required>
                            <el-radio v-for="item in dataTypeList" v-model="computedField.dataType" :label="item.value" :key="item.value">{{item.label}}</el-radio>
                        </el-form-item>
                        <!-- 数据类型 -->
                        <el-form-item prop="fieldType" label="数据类型：" required>
                            <el-radio v-for="item in fieldTypeList" v-model="computedField.fieldType" :label="item.value" :key="item.value">{{item.label}}</el-radio>
                        </el-form-item>
                        <!-- 格式化 -->
                        <el-form-item prop="formatter" label="格式化：">
                            <el-input v-model="computedField.formatter" size="small" :clearable="true" style="width: 300px"></el-input>
                            <div v-if="computedField.fieldType === 'STRING'" class="myTips">可用占位符：{value}：该列的行数据，{label}：列名</div>
                            <div v-else-if="computedField.fieldType === 'NUMBER'" class="myTips">显示格式，例如￥#,##0.00%，长度不超过50个字符且小数点最多只能有一个</div>
                            <div v-else-if="computedField.fieldType === 'DATE'" class="myTips">显示格式，例如yyyy-MM-dd HH:mm:ss，y：年，M：月，d：日，H：24小时，h：12小时，m：分，s：秒，S：毫秒</div>
                        </el-form-item>
                        <!-- 备注 -->
                        <el-form-item prop="bz" label="备注：">
                            <el-input v-model="computedField.description" size="small" :clearable="true" style="width: 300px"></el-input>
                        </el-form-item>
                    </el-form>
                </div>
                <!-- 函数列表 -->
                <div style="width: 48%;height:100%;" class="inline">
                    <el-row>
                        <el-input v-model="functionFilter" size="mini" style="width: 300px;float: right" clearable prefix-icon="el-icon-search"></el-input>
                    </el-row>
                    <el-row>
                        <el-table :data="showFunctionList" height="600px">
                            <el-table-column type="expand">
                                <template slot-scope="scope">
                                    <el-form label-position="left" label-width="80px">
                                        <el-form-item prop="functionName" label="函数名">
                                            {{scope.row.functionName}}
                                        </el-form-item>
                                        <el-form-item prop="functionUsage" label="函数用法">
                                            {{scope.row.functionUsage}}
                                        </el-form-item>
                                        <el-form-item prop="functionDescription" label="函数说明">
                                            {{scope.row.functionDescription}}
                                        </el-form-item>
                                    </el-form>
                                </template>
                            </el-table-column>
                            <el-table-column label="函数名" prop="functionName"></el-table-column>
                            <el-table-column label="函数用法" prop="functionUsage"></el-table-column>
                        </el-table>
                    </el-row>
                </div>
            </div>
            <el-row style="margin-top: 10px">
                <el-button style="float: right" type="primary" size="small" @click="addOrUpdateComputedField(computedFieldEdit)">确认</el-button>
                <el-button style="float: right;margin-right: 10px" type="primary" size="small" @click="dialogShow = false">关闭</el-button>
            </el-row>
        </el-dialog>
        <!-- 保存编辑框 -->
        <el-dialog :close-on-click-modal="false" :visible.sync="saveDialogShow">
            <template slot="title">
                <label class="collapseTitle">设置数据集名称和类别</label>
            </template>
            <el-form ref="lastStep" :model="formData" label-width="100px">
                <el-form-item prop="sjjMc" label="数据集名称：" :rules="{validator: sjjmcExisted, trigger: 'change'}">
                    <el-input v-model="formData.sjjMc" size="small" style="width: 300px;"></el-input>
                </el-form-item>
                <el-form-item label="分类：">
                    <el-tree :data="treeData"
                             node-key="flId"
                             :current-node-key="formData.flId"
                             :props="{label: 'flMc'}"
                             :expand-on-click-node="false"
                             :highlight-current="true"
                             :default-expand-all="true"
                             :accordion="true"
                             @node-click="clickNode">
                    </el-tree>
                </el-form-item>
                <el-form-item>
                    <el-button style="float: right;" size="mini" type="primary" @click="saveDialogShow = false">关闭</el-button>
                    <el-button style="float: right;margin-right: 10px" size="mini" type="primary" :disabled="!ok || !checkName()" @click="complete">提交</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
        <!-- 自定义格式化编辑框 -->
        <el-dialog :close-on-click-modal="false" :visible.sync="customFormatDialog" title="自定义格式化" width="550px">
            <!-- 字符串格式化 -->
            <el-form v-if="customFormatType === '3'">
                <el-form-item label="格式化模板：">
                    <el-input type="textarea" resize="none" v-model="customFormatData.formatter" maxlength="250" show-word-limit></el-input>
                    <div class="myTips">可用占位符：{value}：该列的行数据，{label}：列名</div>
                </el-form-item>
            </el-form>
            <!-- 日期/数值格式化 -->
            <el-form v-else>
                <!-- 格式化 -->
                <el-form-item prop="formatter" label="格式化：">
                    <el-input v-model="customFormatData.formatter" size="small" :clearable="true" style="width: 500px;"></el-input>
                    <div v-if="customFormatType === '1'" class="myTips">显示格式，例如￥#,##0.00%，长度不超过50个字符且小数点最多只能有一个</div>
                    <div v-if="customFormatType === '2'" class="myTips">显示格式，例如yyyy-MM-dd HH:mm:ss，y：年，M：月，d：日，H：24小时，h：12小时，m：分，s：秒，S：毫秒</div>
                </el-form-item>
            </el-form>
            <el-row style="margin-top: 10px">
                <el-button style="float: right" type="primary" size="small" @click="commitCustomFormat">确认</el-button>
                <el-button style="float: right;margin-right: 10px" type="primary" size="small" @click="customFormatDialog = false">关闭</el-button>
            </el-row>
        </el-dialog>
        <!-- 字段管理编辑框 -->
        <el-dialog :visible.sync="fieldManger" title="字段管理" :close-on-click-modal="false">
            <template v-for="item in groupUpFieldsByFieldTypeTrans">
                <el-divider :key="item.title" content-position="left" class="sjj_field_manger_item_splitLine">{{item.title}}</el-divider>
                <div style="padding-left: 20px">
                    <template v-for="(field, index) in item.data">
                        <el-checkbox :key="field.fieldName"
                                     v-model="field.isqy"
                                     :false-label="'0'"
                                     :true-label="'1'">
                            <div class="myTextOver sjj_field_manger_item" :title="field.fieldName">
                                {{field.fieldAlias}}
                            </div>
                        </el-checkbox>
                    </template>
                </div>
            </template>
        </el-dialog>
        <el-row v-loading="loading !== 0" key="table" style="height: 100%">
            <!--                        <el-button type="primary" size="small" @click="showData = false">返回</el-button>-->
            <el-button type="primary" style="float: right;margin-top: 5px;margin-bottom: 5px" size="mini" @click="openAdd">新增计算字段</el-button>
            <el-button type="primary" style="float: right;margin-top: 5px;margin-bottom: 5px;margin-right: 10px" size="mini" icon="el-icon-refresh" @click="executeSql(true, false, 'SJJ', false)">刷新数据</el-button>
            <!--                        <el-button class="stepButtonStep" type="primary" style="float: right" size="small" :disabled="!isOk(3) || !ok" @click="complete">保存</el-button>-->
            <el-button type="primary" style="float: right;margin-top: 5px;margin-bottom: 5px;" size="mini" :disabled="!isOk(3)" @click="saveDialogShow = true" icon="el-icon-upload">保存数据集</el-button>
            <el-button type="primary" style="float: right;margin-top: 5px;margin-bottom: 5px;" size="mini" @click="fieldManger = true" icon="el-icon-upload">字段管理</el-button>
            <el-table :data="tableData"
                      style="margin-top: 10px"
                      ref="sjjDataTable"
                      :border="true"
                      :key="tableKey"
                      :height="tableHeight">
                <el-table-column v-for="item in tableColumns"
                                 :key="item.fieldName"
                                 :prop="item.fieldName"
                                 v-if="item.isqy === '1'"
                                 min-width="180px">
                    <div slot="header" style="height: 40px">
                        <el-row style="width: 100%;">
                            <el-col :span="20" :title="getHeardTooltip(item)">
                                <div class="headerStyle myTextOver" :style="{color: getColor(item)}">
                                    <svg-icon :icon-class="getDataIcon(item)" class="iconStyle"></svg-icon>
                                    <label>{{'(' + (item.dataType === '1' ? '维度' : '度量') + ')'}}</label>
                                    <label style="color: black;margin-left: 3px" :style="{textDecoration: item.fieldAlias === item.fieldName ? '' : 'underline'}">{{item.fieldAlias}}</label>
                                </div>
                            </el-col>
                            <el-col :span="4">
                                <!-- 字段菜单 -->
                                <el-popover popper-class="myPopover" style="float: right" trigger="click" width="150px" placement="bottom-start">
                                    <template slot="reference">
                                        <el-button style="margin-top: 15px" type="text"><i class="el-icon-setting"></i></el-button>
                                    </template>
                                    <div class="rightClickMenu">
                                        <!-- 删除字段 -->
                                        <div class="rightClickMenuItem"><el-button type="text" @click="removeField(item)"><i class="el-icon-delete"></i>删除字段</el-button></div>
                                        <!-- 重命名 -->
                                        <div class="rightClickMenuItem" v-if="item.isComputed === '0'"><el-button type="text" @click="openRename(item)"><i class="el-icon-edit"></i>重命名</el-button></div>
                                        <!-- 编辑字段（仅限计算字段） -->
                                        <div class="rightClickMenuItem"  v-if="item.isComputed === '1'"><el-button type="text" @click="openEdit(item)"><i class="el-icon-edit-outline"></i>编辑计算字段</el-button></div>
                                        <!-- 维度和度量的转换 -->
                                        <div class="rightClickMenuItem">
                                            <el-button v-if="item.dataType === '1'" type="text" @click="dataTypeChange(item, '2')"><i class="el-icon-refresh"></i>切换为度量</el-button>
                                            <el-button v-else type="text" @click="dataTypeChange(item, '1')"><i class="el-icon-refresh"></i>切换为维度</el-button>
                                        </div>
                                        <!-- 字段格式化选项（仅限数值和日期） -->
                                        <div class="rightClickMenuItem" :key="tableKey + item.fieldName" v-if="parseInt(item.fieldTypeTrans) < 3">
                                            <el-popover popper-class="myPopover" trigger="hover" width="180px" placement="right-start">
                                                <template slot="reference">
                                                    <el-button type="text" v-if="item.fieldTypeTrans === '1'">
                                                        <div style="width: 70%;display: inline-block">
                                                            <i class="el-icon-brush"></i>数字格式化
                                                        </div>
                                                        <div style="width: 30%;text-align: right;display: inline-block">
                                                            <i class="el-icon-caret-right"></i>
                                                        </div>
                                                    </el-button>
                                                    <el-button type="text" v-else>
                                                        <div style="width: 70%;display: inline-block">
                                                            <i class="el-icon-brush"></i>日期格式化
                                                        </div>
                                                        <div style="width: 30%;text-align: right;display: inline-block">
                                                            <i class="el-icon-caret-right"></i>
                                                        </div>
                                                    </el-button>
                                                </template>
                                                <div class="rightClickMenu">
                                                    <template v-if="item.fieldTypeTrans === '1'">
                                                        <div v-for="opt in numberFormatOptions" :key="opt.value" class="rightClickMenuItem">
                                                            <el-button v-if="selected(item, opt)" class="formatOption formatOption_selected" type="text" @click="formatterChange(item, opt)">{{opt.label}}<i style="margin-left: 15px" class="el-icon-check"></i></el-button>
                                                            <el-button v-else class="formatOption" type="text" @click="formatterChange(item, opt)">{{opt.label}}</el-button>
                                                        </div>
                                                    </template>
                                                    <template v-else>
                                                        <div v-for="opt in dateFormatOptions" :key="opt.value" class="rightClickMenuItem">
                                                            <el-button v-if="selected(item, opt)" class="formatOption formatOption_selected" type="text" @click="formatterChange(item, opt)">{{opt.label}}<i style="margin-left: 15px" class="el-icon-check"></i></el-button>
                                                            <el-button v-else class="formatOption" type="text" @click="formatterChange(item, opt)">{{opt.label}}</el-button>
                                                        </div>
                                                    </template>
                                                </div>
                                            </el-popover>
                                        </div>
                                        <!-- 字段自定义格式化 -->
                                        <div class="rightClickMenuItem">
                                            <el-button type="text" @click="openCustomFormatEdit(item)"><i class="el-icon-magic-stick"></i>自定义格式化</el-button>
                                        </div>
                                    </div>
                                </el-popover>
                            </el-col>
                        </el-row>
                    </div>
                    <template slot-scope="scope">
                        <span>{{$comUtils.isEmpty(scope.row[item.fieldName]) ? '' : $comUtils.formatter({value: scope.row[item.fieldName], label: item.fieldName}, item.formatter, item.fieldTypeTrans)}}</span>
                    </template>
                </el-table-column>
            </el-table>
            <Pagination :currentPage="currentPage"
                        :total="total"
                        :limit="currentPageSize"
                        :small="true"
                        :pageSizes="[5, 10, 15, 20]"
                        @handleCurrentChange="currentPageChange"
                        @handleSizeChange="currentPageSizeChange"/>
        </el-row>
    </div>
</template>

<script>
    import Coder from "../../components/Coder";
    import CustomCoder from "../../components/CustomCoder";

    let scheduler;
    export default {
        name: "sjjeditor",
        components: {CustomCoder, Coder},
        data:function () {
            return {
                // 页面高度
                screenHeight: 0,
                // 数据集信息
                formData: {
                    sjjId: '',
                    sqlText: '',
                    srcId: '',
                    sjjMc: '',
                    flId: 'ALL'
                },
                // 是否可保存
                ok: true,
                // 当前展开的折叠面板
                collapse: '',
                // sql最后更新时间
                sqlLastUpdate: 0,
                // sql结果集结构最后更新时间
                sqlResultStructureLastUpdate: 0,
                // 分类信息
                treeData: [],
                // 字段类型列表
                dataTypeList: [
                    {label: '维度', value: '1'},
                    {label: '度量', value: '2'},
                ],
                // 字段数据类型列表
                fieldTypeList: [
                    {label: '数值', value: 'NUMBER'},
                    {label: '文本', value: 'STRING'},
                    {label: '日期', value: 'DATE'},
                ],
                // 步骤 弃用
                step: 1,
                // 步骤列表 弃用
                steps: [
                    {title: '设置数据源', icon: 'el-icon-setting', description: '指定使用哪一个数据连接下的数据',status: 'process'},
                    {title: '写SQL', icon: 'el-icon-edit', description: '通过输入SQL语句建立数据', status: 'wait'},
                    {title: '填写名称', icon: 'el-icon-postcard', description: '设置数据集的名称', status: 'wait'},
                ],
                // 数据源可选项
                srcOptions: [],
                // 数据源对象
                srcObj: {},
                // SQL 编辑框 自动提示选项
                autoCompleteOption: {
                    test: []
                },
                // 数据集预览 表格key
                tableKey: '15141435844684_912455365421365',
                // 数据集预览 表数据
                tableData: [],
                // 数据集预览 列信息
                tableColumns: [],
                // 数据集预览 当前页
                currentPage: 1,
                // 数据集预览 当前页大小
                currentPageSize: this.$store.state.pageSizes[0],
                // 数据集预览 总条数
                total: 0,
                // SQL 编辑框 sql异常信息显示状态
                error: false,
                // SQL 编辑框 sql异常信息
                errorMessage: '',
                // 数据集预览 是否可查看
                showData: false,
                // 数据集预览 加载状态
                loading: 0,
                // 数据源结构 假分页全部数据
                tablesData: [],
                // 数据源结构 假分页数据
                tablesShowData: [],
                // 数据源结构 总条数
                tablesTotal: 0,
                // 数据源表结构树props
                treeProps: {
                    label: 'label',
                    children: 'children',
                    isLeaf: 'isLeaf'
                },
                // 数据源结构分页 - 当前页 弃用
                tablesCurrentPage: 1,
                // 数据源结构分页 - 当前页大小 弃用
                tablesCurrentPageSize: this.$store.state.pageSizes[0],
                // 数据源结构加载状态 弃用
                tablesLoading: false,
                // 计算字段属性
                computedField: {
                    fieldName: '',
                    fieldAlias: '',
                    expression: '',
                    fieldType: 'NUMBER',
                    fieldTypeTrans: '0',
                    dataType: '1',
                    isComputed: '1',
                    description: '',
                    xh: 0,
                    isqy: '1',
                    formatter: '',
                    fieldIndex: 0
                },
                // 正在编辑的计算字段的原始数据
                computedFieldBackUp: {},
                // 计算字段编辑框显示状态
                dialogShow: false,
                // 保存对话框状态
                saveDialogShow: false,
                // 标记 计算字段编辑框 是编辑还是新建
                computedFieldEdit: false,
                // 计算字段编辑框标题
                dialogTitle: '新增计算字段',
                // 计算字段函数列表
                functionList: [
                    // {functionName: '加法', functionUsage: 'a + b', functionDescription: '将a字段和b字段的值相加'},
                ],
                // 计算字段函数过滤
                functionFilter: '',
                // 是否是编辑状态，否则为新建状态
                isEdit: false,
                // sql 执行次数
                clickExecuteSqlNum: 0,
                // 数字格式化选项
                numberFormatOptions: [
                    {label: '#,###,##0', value: '###,###,###,###,##0'},
                    {label: '#,###,##0.0', value: '###,###,###,###,##0.0'},
                    {label: '#,###,##0.00', value: '###,###,###,###,##0.00'},
                    {label: '#,###,##0.000', value: '###,###,###,###,##0.000'},
                    {label: '#,###,##0.0000', value: '###,###,###,###,##0.0000'},
                    {label: '无', value: ''},
                ],
                // 日期格式化选项
                dateFormatOptions: [
                    {label: 'yyyyMMdd', value: 'yyyyMMdd'},
                    {label: 'yyyy-MM-dd', value: 'yyyy-MM-dd'},
                    {label: 'yyyy/MM/dd', value: 'yyyy/MM/dd'},
                    {label: 'yyyy-MM-dd HH:mm:ss', value: 'yyyy-MM-dd HH:mm:ss'},
                    {label: 'yyyy/MM/dd HH:mm:ss', value: 'yyyy/MM/dd HH:mm:ss'},
                    {label: '无', value: ''},
                ],
                // 日期类型的数据的默认格式
                dateDefaultFormat: 'yyyy-MM-dd HH:mm:ss',
                // 自定义格式化对话框显示状态
                customFormatDialog: false,
                // 自定义格式化 类型
                customFormatType: 3,
                // 自定义格式化 格式化信息
                customFormatData: {
                    formatter: '',
                },
                // 自定义格式化 操作的目标字段
                customFormatTarget: undefined,
                // 重命名对话框状态
                renameDialog: false,
                // 重命名值
                rename: '',
                // 重命名的字段
                renameTarget: {},
                // 字段管理状态
                fieldManger: false,
                // 数据源是否可用
                srcDisabled: false
            }
        },
        methods: {
            /** 上/下一步点击处理 */
            stepButtonClickHandler: function (stepping) {
                this.showData = false;
                this.step += stepping;
            },
            /** 获取步骤当状态 */
            stepStatus: function (index) {
                if (index + 1 > this.step) {
                    return 'wait';
                }   else if (index + 1 === this.step) {
                    return this.isOk(this.step) ? 'success' : 'process';
                } else {
                    return this.isOk(index + 1) ? 'success' : 'error';
                }
            },
            /** 步骤条点击事件 */
            stepClick: function (index) {
                if (this.isOk(index)) {
                    this.step = index + 1;
                }
            },
            /** 数据检视当前页变化 */
            currentPageChange_tables: function (garbage, val) {
                this.tablesCurrentPage = val;
                this.falsePagination(val, this.tablesCurrentPageSize);
            },
            /** 数据检视页大小变化 */
            currentPageSizeChange_tables: function (garbage, val) {
                this.tablesCurrentPageSize = val;
                this.falsePagination(this.tablesCurrentPage, val);
            },
            /** 假分页 */
            falsePagination: function (page, rows) {
                let start = (page - 1) * rows;
                let end = page * rows;
                end = end < this.tablesData.length ? end : this.tablesData.length;
                this.tablesShowData = this.tablesData.slice(start, end);
            },

            /** ================================================ 有效区 ==================================================== */
            /** 加载数据源的所有表 */
            loadAllTables: function (srcId) {
                if (this.$comUtils.isEmpty(srcId)) {
                    return;
                }
                let req = {
                    srcId: srcId
                }
                this.tablesLoading = true;
                this.$requestUtil.simplePost('/api/sjj/getSrcTablesInfo', req, res => {
                    // debugger
                    this.tablesData = res.data.data;
                    this.tablesTotal = res.data.data.length;
                    this.tablesShowData = [];
                    this.tablesCurrentPage = 1;
                    // this.falsePagination(this.tablesCurrentPage, this.tablesCurrentPageSize);
                }, () => {
                    this.tablesLoading = false;
                })
            },
            /** 加载表字段 */
            loadTableFields: function (node, callback) {
                let result = []
                // 一级节点 （表/视图）
                if (node.level === 1) {
                    let req = {
                        tableName: node.data.label,
                        srcId: this.formData.srcId
                    }
                    this.$requestUtil.simplePost('/api/sjj/getTableStructure', req, res => {
                        let data = res.data.data;
                        for (let i = 0; i < data.length; i++) {
                            let obj = {
                                label: data[i].fieldName,
                                isLeaf: false,
                                allData: data[i],
                            }
                            result.push(obj);
                        }
                        callback(result);
                    })
                }
                // 二级节点 （字段）
                else if (node.level === 2) {
                    let nodeData = node.data.allData;
                    result = [
                        {label: '字段类型: ' + nodeData.fieldType, isLeaf: true},
                        {label: '字段说明: ' + (this.$comUtils.isEmpty(nodeData.description) ? '无' : nodeData.description), isLeaf: true},
                        // {label: '所属表: ' + nodeData.tableName, isLeaf: true},
                    ]
                    if (this.$comUtils.isNotEmpty(nodeData.fieldSize)) {
                        result.splice(1, 0, {label: '字段长度: ' + nodeData.fieldSize, isLeaf: true});
                    }
                    callback(result);
                }
            },
            /** 当前步骤及前置步骤是否合法 */
            isOk: function (step) {
                let flag = true;
                if (step >= 1) {
                    // flag = flag && this.checkName();
                }
                if (step >= 2) {
                    flag = flag && this.checkSrc();
                }
                if (step >= 3) {
                    flag = flag && this.checkSql() && this.showData;
                }
                return flag;
            },
            /** 检查数据源是否合法 */
            checkSrc: function () {
                if (this.$comUtils.isEmpty(this.formData.srcId)) {
                    return false;
                }
                return true;
            },
            /** 检查sql是否合法 */
            checkSql: function () {
                return !this.$comUtils.isEmpty(this.formData.sqlText);
            },
            /** 检查名称是否合法 */
            checkName: function () {
                if (this.$comUtils.isEmpty(this.formData.sjjMc)) {
                    return false;
                }
                return true;
            },
            /** 点击保存 */
            complete: function () {
                if (!this.isOk(3) || !this.ok || !this.checkName()) {
                    this.$message.warning('有未完成步骤！请完成所有步骤');
                    return;
                }
                let req = {
                    sjjId: this.formData.sjjId,
                    sqlText: this.formData.sqlText,
                    srcId: this.formData.srcId,
                    sjjMc: this.formData.sjjMc,
                    flId: this.formData.flId,
                    isqy: '1',
                    fields: this.tableColumns,
                    removeAll: this.sqlLastUpdate > this.sqlResultStructureLastUpdate && this.clickExecuteSqlNum > 0
                }
                if (this.$comUtils.isEmpty(this.formData.sjjId)) {
                    this.$requestUtil.simplePost('/api/sjj/addSjj', req, (res) => {
                        this.$message.success('保存成功！');
                        this.saveDialogShow = false;
                    })
                } else {
                    this.$requestUtil.simplePost('/api/sjj/updateSjj', req, (res) => {
                        this.$message.success('保存成功！');
                        this.saveDialogShow = false;
                    })
                }
                this.$comUtils.saveObjArr('reflushSjj', true);
            },
            /** 加载数据源 */
            loadSrc: async function () {
                let req = {
                    srcCurrentPage: 0
                }
                this.$requestUtil.simplePost('/api/sjy/getConnList', req, res => {
                    this.srcOptions = res.data.data;
                })
            },
            /** 加载自动提示信息 */
            loadAutoCompleteItem: function (srcId) {
                if (this.$comUtils.isEmpty(srcId)) {
                    return;
                }
                let req = {
                    srcId: srcId
                }
                this.$requestUtil.simplePost('/api/sjj/getDbAllTableFields', req, res => {
                    this.autoCompleteOption = res.data.data;
                })
            },
            /** 加载SQL的表结构 */
            loadSQLResultStructure: function () {
                this.loading ++;
                let req = {
                    sql: this.formData.sqlText,
                    srcId: this.formData.srcId,
                    sjjId: this.formData.sjjId
                }
                this.sqlResultStructureLastUpdate = new Date().getTime();
                this.$ajax.post('/api/sjj/getResultSetStructureBySql', req).then(res => {
                    if (res.data.code === 200) {
                        this.error = false;
                        for (let i = 0; i < res.data.data.length; i++) {
                            let item = res.data.data[i];
                            item.fieldTypeTrans = this.$comUtils.getFieldType(item);
                            if (item.fieldTypeTrans === '2') {
                                item.formatter = this.dateDefaultFormat;
                            }
                            item.dataType = item.fieldTypeTrans === '1' ? '2' : '1';
                        }
                        this.tableColumns = res.data.data;
                        this.resetTableKey();
                        this.showData = true;
                    } else {
                        this.error = true;
                        this.showData = false;
                        this.errorMessage = res.data.message;
                        this.$message.error(this.errorMessage);
                    }
                }).finally(() => {
                    this.loading --;
                })
            },
            /** 预览执行sql 参数：resetPage：是否重置分页；resetStructure：是否重置数据结构；
             * executeType：执行类型（SQL还是SJJ）；jump：是否跳转到编辑数据集 */
            executeSql: function (resetPage, resetStructure, executeType, jump) {
                if (resetPage) {
                    this.currentPage = 1;
                }
                if (this.$comUtils.isEmpty(this.formData.sqlText.trim())) {
                    this.error = true;
                    this.errorMessage = 'SQL语句不能为空';
                    this.$message.error(this.errorMessage);
                    return;
                }
                let req = {
                    sql: this.formData.sqlText,
                    srcId: this.formData.srcId,
                    currentPage: this.currentPage,
                    fields: this.tableColumns,
                    limit: this.currentPageSize,
                }
                this.loading ++;
                this.$ajax.post(executeType === 'SJJ' ? '/api/sjj/executeSjj' : '/api/sjj/executeSql', req).then(res => {
                    if (res.data.code === 200) {
                        this.error = false;
                        this.tableData = res.data.data.data;
                        this.total = res.data.data.total;
                        if (resetStructure) {
                            this.clickExecuteSqlNum ++;
                            this.loadSQLResultStructure();
                        } else {
                            this.showData = true;
                        }
                    } else {
                        this.error = true;
                        // this.showData = false;
                        this.errorMessage = res.data.message;
                        this.$message.error(this.errorMessage);
                        if (jump) {
                            this.collapse = '3';
                        }
                    }
                }).finally(() => {
                    this.loading --;
                });
                if (jump) {
                    // 延迟跳转
                    setTimeout(() => {
                        if (!this.error) {
                            this.collapse = '4';
                        }
                    }, 200);
                }
            },
            /** 数据检视当前页变化 */
            currentPageChange: function (garbage, val) {
                this.currentPage = val;
                this.executeSql(false, false, 'SJJ', true);
            },
            /** 数据检视页大小变化 */
            currentPageSizeChange: function (garbage, val) {
                this.currentPageSize = val;
                this.currentPage = 1;
                this.executeSql(false, false, 'SJJ', true);
            },
            /** 数据检视字段图标 */
            getDataIcon: function (item) {
                switch (this.$comUtils.getFieldType(item)) {
                    case '1':
                        return 'number';
                    case '2':
                        return 'datetime';
                    case '3':
                        return 'string';
                }
                return '';
            },
            /** 分类数组转换为树（已分组） */
            transformToTree: function (data, start, jc) {
                let array = [];
                let index;
                for (let i = start; i < data.length; i++) {
                    if (data[i].jc < jc) {
                        index = i - 1;
                        break;
                    }
                    if (data[i].jc > jc) {
                        let last = array[array.length - 1];
                        let child = this.transformToTree(data, i, jc + 1);
                        last.children = child.array;
                        i = child.index;
                    } else {
                        let item = jQuery.extend(true, {}, data[i]);
                        item.children = [];
                        array.push(item);
                    }
                }
                return {
                    index: index,
                    array: array
                }
            },
            /** 加载所有分类 */
            loadAllFl: function (){
                this.$requestUtil.simplePost('/api/sjj/getAllFl', {}, res => {
                    let toTree = this.transformToTree(res.data.data, 0, 1);
                    let root = {
                        flId: 'ALL',
                        flMc: '全部',
                        children: toTree.array,
                        jc: 0
                    }
                    this.treeData = [root];
                });
            },
            /** 点击分类 */
            clickNode: function(data, node) {
                this.formData.flId = data.flId;
            },
            /** 数据类型改变 */
            dataTypeChange: function (item, command) {
                item.dataType = command;
                this.resetTableKey();
            },
            /** 获取数据源图标 */
            getSrcIcon: function (type) {
                switch (type) {
                    case '1':
                        return 'mySql';
                    case '2':
                        return 'sqlServer';
                    case '4':
                        return 'oracle';
                    case '5':
                        return 'csv';
                    case '6':
                        return 'excel'
                }
                return '';
            },
            /** 获取数据源背景色 */
            getSrcBackground: function (type) {
                switch (type) {
                    case '1':
                        return 'rgb(234, 186, 25)';
                    case '2':
                        return 'rgb(161, 155, 168)';
                    case '4':
                        return 'rgb(255, 116, 116)';
                    case '5':
                        return 'rgb(104, 182, 176)';
                    case '6':
                        return 'rgb(43, 192, 72)';
                }
                return '';
            },
            /** 获取字体+图标颜色 */
            getColor: function (item) {
                switch (item.dataType) {
                    case '1':
                        return '#468cff';
                    case '2':
                        return '#64bd4f'
                }
                return '';
            },
            /** 数据集名称是否存在 */
            sjjmcExisted: function (rule, value, callback) {
                let req = {
                    sjjMc: value,
                    sjjId: this.formData.sjjId
                }
                this.ok = false;
                if (this.$comUtils.isEmpty(value)) {
                    callback(new Error('数据集名称不能为空'));
                    return;
                }
                this.$requestUtil.simplePost('/api/sjj/sjjmcIsExisted', req, res => {
                    if (res.data.data) {
                        callback(new Error('该名称已存在'));
                    } else {
                        callback();
                        this.ok = true;
                    }
                })
            },
            /** 删除字段 */
            removeField: function (item) {
                this.$confirm('此操作将永久删除该字段, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.removeFieldInner(item);
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    });
                }).catch(() => {});
            },
            /** 删除字段 */
            removeFieldInner: function (item) {
                for (let i = 0; i < this.tableColumns.length; i++) {
                    let one = this.tableColumns[i];
                    if (one.fieldName === item.fieldName) {
                        one.isqy = '0';
                    }
                }
            },

            getComputedFiledName: function (len) {
                let randomPool = ['A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T',
                    'U','V','W','X','Y','Z','0','1','2','3','4','5','6','7','8','9', '_'];
                let res = 'COMPUTED_';
                while (res.length < len) {
                    let number = Math.floor(Math.random() * 370) % randomPool.length;
                    res += randomPool[number];
                }
                return res;
            },
            /** 打开计算字段添加框 */
            openAdd: function () {
                this.dialogTitle = '新增计算字段';
                this.computedField.dataType = '2';
                this.computedField.expression = '';
                this.computedField.fieldName = this.getComputedFiledName(25);
                this.computedField.fieldAlias = '';
                this.computedField.fieldType = 'NUMBER';
                this.computedField.isComputed = '1';
                this.computedField.description = '';
                this.computedField.formatter = '';
                this.functionFilter = '';
                let max = this.tableColumns.length;
                for (let i = 0; i < this.tableColumns.length; i++) {
                    max = Math.max(this.tableColumns[i].xh, max);
                }
                this.computedField.xh = max;
                this.computedFieldBackUp = {};
                this.computedFieldEdit = false;
                this.dialogShow = true;
            },
            /** 打开计算字段编辑框 */
            openEdit: function (item) {
                this.dialogTitle = '编辑计算字段';
                this.computedField.dataType = item.dataType;
                this.computedField.expression = this.replaceNameToAlias(item);
                this.computedField.fieldName = item.fieldName;
                this.computedField.fieldAlias = item.fieldAlias;
                this.computedField.fieldType = item.fieldType;
                this.computedField.isComputed = '1';
                this.computedField.xh = item.xh;
                this.computedField.formatter = item.formatter;
                this.computedField.description = this.$comUtils.isEmpty(item.description) ? '' : item.description;
                this.functionFilter = '';
                this.computedFieldBackUp = item;
                this.computedFieldEdit = true;
                this.dialogShow = true;
            },
            /** 添加计算字段 */
            addOrUpdateComputedField: function (update) {
                if (this.$comUtils.isEmpty(this.computedField.fieldAlias)) {
                    this.$message.warning('请输入字段名');
                    return;
                }
                if (this.usedFieldName.indexOf(this.computedField.fieldName.toUpperCase()) >= 0
                    || this.usedFieldAlias.indexOf(this.computedField.fieldAlias) >= 0) {
                    this.$message.warning('字段名重复');
                    return;
                }
                if (this.$comUtils.isEmpty(this.computedField.expression)) {
                    this.$message.warning('请输入表达式');
                    return;
                }
                // 别名替换为真实字段名
                let expressionReal = this.replaceAliasToName(this.computedField);
                this.computedField.expression = expressionReal;
                this.computedField.fieldTypeTrans = this.$comUtils.getFieldType(this.computedField);
                if (this.computedField.fieldTypeTrans === '2' && this.$comUtils.isEmpty(this.computedField.formatter)) {
                    this.computedField.formatter = this.dateDefaultFormat;
                }
                this.computedField.fieldName = this.computedField.fieldName.toUpperCase();
                // 深copy 防止共用对象
                let datum = jQuery.extend(true, {}, this.computedField);
                if (update) {
                    for (let i = 0; i < this.tableColumns.length; i++) {
                        if (this.tableColumns[i].fieldName === this.computedFieldBackUp.fieldName) {
                            this.tableColumns.splice(i, 1, datum);
                            break;
                        }
                    }
                } else {
                    this.tableColumns.push(datum);
                }
                // this.getAndRemoveComputedFieldUsedFields(datum);
                this.resetTableKey();
                this.dialogShow = false;
            },
            /** 将表达式中的别名替换为字段名 */
            replaceAliasToName: function (computedField) {
                let regex = new RegExp(/{([a-zA-Z_0-9\u4e00-\u9fa5]+)}/, 'g');
                let exec;
                let res = computedField.expression;
                let fields = this.tableColumns;
                while ((exec = regex.exec(computedField.expression)) !== null) {
                    let filter = fields.filter(val => {
                        return val.fieldAlias === exec[1];
                    });
                    if (filter.length > 0 && exec.length > 1) {
                        res = res.replace(exec[1], filter[0].fieldName);
                    }
                }
                return res;
            },
            /** 将表达式中的字段名替换为别名 */
            replaceNameToAlias: function (computedField) {
                computedField.expression = this.$comUtils.isEmpty(computedField.expression) ? '' : computedField.expression;
                let regex = new RegExp(/{([a-zA-Z_0-9\u4e00-\u9fa5]+)}/, 'g');
                let exec;
                let res = computedField.expression;
                let fields = this.tableColumns;
                while ((exec = regex.exec(computedField.expression)) !== null) {
                    let filter = fields.filter(val => {
                        return val.fieldName === exec[1];
                    });
                    if (filter.length > 0 && exec.length > 1) {
                        res = res.replace(exec[1], filter[0].fieldAlias);
                    }
                }
                return res;
            },
            /** 判断计算字段是否是文本 */
            isString: function (text) {
                let search = text.search(new RegExp(this.stringFields));
                return search >= 0;
            },
            /** 加载结果集结构 */
            loadResultStructureByTable: function (loadData) {
                let req = {
                    sjjId: this.formData.sjjId
                }
                this.$requestUtil.simplePost('/api/sjj/getSjjResultStructureByTable', req, res => {
                    for (let i = 0; i < res.data.data.length; i++) {
                        let item = res.data.data[i];
                        item.fieldTypeTrans = this.$comUtils.getFieldType(item);
                    }
                    this.tableColumns = res.data.data;
                    this.showData = true;
                    if (loadData) {
                        this.executeSql(true, false, 'SJJ', true);
                    }
                })
            },
            /** 加载函数列表 */
            loadFunctionList: function () {
                let req = {
                    srcType: this.srcObj.srcType
                }
                this.$requestUtil.simplePost('/api/sjj/getFunctionList', req, res => {
                    this.functionList = res.data.data;
                })
            },
            /** 检查是否选中 */
            selected: function (column, opt) {
                return column.formatter === opt.value || (this.$comUtils.isEmpty(column.formatter) && opt.value === '');
            },
            /** 重置表的key */
            resetTableKey: function () {
                // 获取当前滚动条位置
                let children = this.$refs.sjjDataTable.$el.children;
                let scrollLeft = children[2].scrollLeft;
                this.tableKey = new Date().getTime() + '_' + Math.floor(Math.random() * 10000000000);
                // 还原滚动条位置
                this.$nextTick(() => {
                    let children = this.$refs.sjjDataTable.$el.children;
                    children[2].scrollTo(scrollLeft, 0);
                })
            },
            /** 格式化选中 */
            formatterChange: function (column, opt) {
                column.formatter = opt.value;
                this.resetTableKey();
            },
            /** 打开自定义格式化编辑框 */
            openCustomFormatEdit: function (item) {
                this.customFormatData.formatter = this.$comUtils.isEmpty(item.formatter) ? '' : item.formatter;
                this.customFormatTarget = item;
                this.customFormatType = item.fieldTypeTrans;
                this.customFormatDialog = true;
            },
            /** 提交自定义格式化 */
            commitCustomFormat: function () {
                this.customFormatTarget.formatter = this.customFormatData.formatter;
                this.customFormatDialog = false;
                this.customFormatTarget = undefined;
                this.customFormatData.formatter = '';
                this.resetTableKey();
            },
            /** 提交重命名 */
            commitRename: function () {
                this.renameTarget.fieldAlias = this.rename;
                this.rename = '';
                this.renameDialog = false;
                this.resetTableKey();
            },
            openRename: function (item) {
                this.renameTarget = item;
                this.rename = item.fieldAlias;
                this.renameDialog = true;
            },
            /** 获取表头提示 */
            getHeardTooltip: function (item) {
                return (item.isComputed === '1' ? '计算字段' : '基础字段') + '，' + item.fieldName + (this.$comUtils.isEmpty(item.description) ? '' : ('，' + item.description));
            },
            /** 限制输入 */
            fieldNameInputCheck: function (val) {
                let regex = /[^a-zA-Z_\u4e00-\u9fa5]/g
                this.computedField.fieldAlias = val.replace(regex, '');
            }
        },
        watch: {
            'formData.srcId': {
                handler: function (nv, ov) {
                    if (!this.$comUtils.isEmpty(nv)) {
                        this.loadAutoCompleteItem(nv);
                        // 保证一定会加载函数列表
                        clearInterval(scheduler);
                        scheduler = setInterval(() => {
                            if (!this.$comUtils.isEmpty(this.srcOptions)) {
                                let filter = this.srcOptions.filter(item => {
                                    return item.srcId === nv;
                                });
                                this.srcObj = filter[0];
                                this.loadFunctionList();
                                clearInterval(scheduler);
                            }
                        });
                        this.loadAllTables(nv);
                    }
                },
                deep: true
            },
            'formData.sqlText': function (nv, ov) {
                this.sqlLastUpdate = new Date().getTime();
                if (this.sqlResultStructureLastUpdate === 0) {
                    this.sqlResultStructureLastUpdate = this.sqlLastUpdate;
                }
            },
            /** 计算属性类型自动设置 */
            // 'computedField.expression': function (nv, ov) {
            //     if (this.isString(nv)) {
            //         this.computedField.fieldType = 'STRING';
            //     } else {
            //         this.computedField.fieldType = 'NUMBER';
            //     }
            // },
            'computedField.fieldType': function (nv, ov) {
                this.computedField.formatter = '';
            },
            collapse: function (nv, ov) {
                // 点击收起时，展开下一级面板
                if (this.$comUtils.isEmpty(nv) && !this.$comUtils.isEmpty(ov)) {
                    let number = parseInt(ov) + 1;
                    if (number > 4) {
                        this.collapse = number - 2 + '';
                        return;
                    }
                    if (this.isOk(number - 1)) {
                        this.collapse = number + '';
                    }
                }
            },
            tableColumns: {
                handler: function (nv, ov) {

                },
                deep: true
            },
        },
        computed: {
            /** 计算字段表达式的自动提示选项 */
            computeFieldAutoComplete: function () {
                let obj = [];
                for (let i = 0; i < this.tableColumns.length; i++) {
                    let item = this.tableColumns[i];
                    if (item.isComputed === '1') {continue;}
                    obj.push({
                        children: [],
                        value: '{' + item.fieldAlias + '}',
                        show: '{' + item.fieldAlias + '}'
                    });
                }
                for (let i = 0; i < this.functionList.length; i++) {
                    let item = this.functionList[i];
                    obj.push({
                        children: [],
                        value: item.functionUsage,
                        show: item.functionUsage
                    });
                }
                return obj;
            },
            /** 所有文本类型的字段 */
            stringFields: function () {
                let arr = '';
                for (let i = 0; i < this.tableColumns.length; i++) {
                    let item = this.tableColumns[i];
                    if (this.$comUtils.getFieldType(item) !== 1) {
                        arr += item.fieldName + '|';
                    }
                }
                arr += '".*"|\'.*\'';
                return arr;
            },
            // 已使用的字段名
            usedFieldName: function () {
                let res = [];
                for (let i = 0; i < this.tableColumns.length; i++) {
                    let item = this.tableColumns[i];
                    if (item.isqy === '1' && this.computedFieldBackUp.fieldName !== item.fieldName) {
                        res.push(item.fieldName.toUpperCase());
                    }
                }
                return res;
            },
            // 已使用的别名（区分大小写）
            usedFieldAlias: function () {
                let res = [];
                for (let i = 0; i < this.tableColumns.length; i++) {
                    let item = this.tableColumns[i];
                    if (item.isqy === '1' && this.computedFieldBackUp.fieldAlias !== item.fieldAlias) {
                        res.push(item.fieldAlias);
                    }
                }
                return res;
            },
            // tables转为树结构
            tableTree: function () {
                let tables = this.tablesData;
                let res = [];
                for (let i = 0; i < tables.length; i++) {
                    let obj = {
                        label: tables[i].tableName,
                        isLeaf: false,
                        children: [],
                    }
                    res.push(obj);
                }
                return res;
            },
            // 自适应高度
            tableHeight: function () {
                return this.screenHeight - 331 + 'px'
            },
            // 过滤后函数列表
            showFunctionList: function () {
                if (this.$comUtils.isEmpty(this.functionFilter)) {
                    return this.functionList;
                } else {
                    return this.functionList.filter(val => {
                        return val.functionName.toLowerCase().includes(this.functionFilter.toLowerCase());
                    });
                }
            },
            // 当前字段列表按fieldTypeTrans分类
            groupUpFieldsByFieldTypeTrans: function () {
                let columns = this.tableColumns;
                let res = [
                    {title: '数值类型', data: []},
                    {title: '日期类型', data: []},
                    {title: '文本类型', data: []},

                ];
                for (let i = 0; i < columns.length; i++) {
                    let item = columns[i];
                    if (item.fieldTypeTrans === '1') {
                        res[0].data.push(item);
                    }else if (item.fieldTypeTrans === '2') {
                        res[1].data.push(item);
                    }else {
                        res[2].data.push(item);
                    }
                }
                return res;
            }
        },
        mounted() {
            // console.log(this.$comUtils.formatter({value:-123.9}, '###,###,##0.00'))
            // console.log(this.$comUtils.formatter('**/*-4=sadsad{dd}djha{dd}fdh,ad{aa}shfad', {value: '哈哈哈'}))
            this.$nextTick(() => {
                let element = document.getElementsByClassName('el-collapse-item__header');
                for (let i = 0; i < element.length; i++) {
                    element[i].style.backgroundColor = this.$comUtils.getXtcs('menubgcolor');
                    element[i].style.color = this.$comUtils.getXtcs('menufontcolor');
                }
            })
            // 用于自适应高度
            this.screenHeight = document.body.clientHeight;
            window.addEventListener('resize', () => {
                this.screenHeight = document.body.clientHeight;
            })
        },

        activated() {
            this.loadSrc();
            this.loadAllFl();
            // 设置数据集初始数据
            this.tableColumns = [];
            this.tableData = [];
            this.showData = false;
            this.$nextTick(() => {
                let objArr = this.$comUtils.getObjArr('sjjInfo');
                if (this.$comUtils.isEmpty(objArr) || this.$comUtils.isEmpty(objArr.mode) || objArr.mode === '0') {
                    // 0或默认 新建数据集
                    this.formData = {
                        sjjId: '',
                        sqlText: '',
                        srcId: '',
                        sjjMc: '',
                        flId: 'ALL'
                    }
                    this.tablesData = [];
                    this.collapse = '3';
                    this.isEdit = false;
                    this.srcDisabled = false;
                } else if (objArr.mode === '1') {
                    // 1 数据源跳转
                    this.formData.sjjId = objArr.sjjId;
                    this.formData.sjjMc = objArr.sjjMc;
                    this.formData.srcId = objArr.srcId;
                    this.formData.sqlText = objArr.sqlText;
                    this.formData.flId = objArr.flId;
                    this.collapse = '4';
                    this.isEdit = false;
                    this.srcDisabled = false;
                    this.executeSql(true, true, 'SQL', false);
                } else if (objArr.mode === '2') {
                    // 2 数据集跳转
                    this.formData.sjjId = objArr.sjjId;
                    this.formData.sjjMc = objArr.sjjMc;
                    this.formData.srcId = objArr.srcId;
                    this.formData.sqlText = objArr.sqlText;
                    this.formData.flId = objArr.flId;
                    this.collapse = '4';
                    this.isEdit = true;
                    this.ok = true;
                    this.srcDisabled = false;
                    this.loadResultStructureByTable(true);
                } else if (objArr.mode === '3') {
                    // 3 数据源跳转（不带表）
                    this.formData.sjjId = objArr.sjjId;
                    this.formData.sjjMc = objArr.sjjMc;
                    this.formData.srcId = objArr.srcId;
                    this.formData.sqlText = 'SELECT\n' +
                        '  col\n' +
                        'FROM\n' +
                        '  TEMP\n' +
                        'WHERE\n' +
                        '  col = \'\'';
                    this.formData.flId = objArr.flId;
                    this.collapse = '4';
                    this.isEdit = true;
                    this.ok = true;
                    this.srcDisabled = true;
                    this.loadResultStructureByTable(true);
                } else {
                    // 99 页面切换状态保存
                    this.formData.sjjId = objArr.sjjId;
                    this.formData.sjjMc = objArr.sjjMc;
                    this.formData.srcId = objArr.srcId;
                    this.formData.sqlText = objArr.sqlText;
                    this.formData.flId = objArr.flId;
                    this.collapse = objArr.collapse;
                    this.tableColumns = objArr.fields;
                    this.showData = objArr.collapse >= '3';
                    this.srcDisabled = objArr.srcDisabled;
                    this.isEdit = false;
                }
            })
        },
        deactivated() {
            // 保存状态，防止刷新丢失数据
            let data = jQuery.extend(true, {}, this.formData);
            data.mode = '99';
            data.collapse = this.collapse;
            data.fields = this.tableColumns;
            data.srcDisabled = this.srcDisabled;
            this.error = false;
            this.$comUtils.saveObjArr('sjjInfo', data);
        },
    }
</script>
<style scoped>
    .cardStyle {
        min-height: 500px;
    }
    .stepButtonStep{
        float: left;
        margin-right: 5px;
    }
    /* 列类型标样式 */
    .iconStyle {
        font-size: 12px;
        display: inline-block;
        vertical-align: middle;
        transform: translateY(-1.5px);
    }
    /* 表头样式 */
    .headerStyle {
        height: 40px;
        /*display: inline-block;*/
        vertical-align: -2.3px;
        line-height: 40px;
        min-width: 132px;
    }

    .tableTreeIconClass {
        width: 1.7em;
        height: 1.7em;
        vertical-align: -0.4em
    }

    .myTextOver {
        overflow-x: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
    /* 异常信息样式 */
    .errorMessageStyle{
        font-size: 25px;
        text-align: center;
        color: red;
        display: inline-block;
        vertical-align: middle;
        font-weight: bold;
    }
    /* 数据源选项图标样式 */
    .iconStyleDb{
        width: 45px;
        height: 45px;
        vertical-align: -8px;
    }
    /* 数据源选项样式 */
    .srcOptionsItemStyle {
        font-size: 15px;
        height: 25px;
        line-height: 25px;
    }
    /* 最后更新时间样式 */
    .timeStyle {
        color: rgba(156, 156, 156, 0.69);
        font-size: 13px;
    }
    /* 列菜单样式 */
    .rightClickMenu {
        width: 180px;
        padding: 0px;
    }
    /* 列菜单选项样式 */
    .rightClickMenuItem {
        height: 25px;
        width: 100%;
        padding-top: 5px;
        /*border-top: 1px solid #9c9c9c;*/
    }
    /* 列菜单选项按钮样式 */
    .rightClickMenuItem .el-button--text {
        font-size: 13px;
        text-align: left;
        color: black;
        padding-top: 5px;
        padding-bottom: 5px;
        padding-left: 15px;
        width: 100%;
        border-radius: 0px;
    }
    .rightClickMenuItem:first-of-type {
        border-top: none;
    }
    /* 列菜单悬停样式 */
    .rightClickMenuItem .el-button--text:hover{
        background-color: rgba(156, 156, 156, 0.42);
        background-repeat: space;
    }
    /* 格式化选项样式 */
    .formatOption {
        text-align: left;
        padding-left: 10px
    }
    /* 格式化选项选中样式 */
    .formatOption_selected {
        color: #1c7cff !important;
    }
    /* 下拉框标题样式 */
    .collapseTitle {
        margin-left: 20px;
    }
    /* 表单提示样式 */
    .myTips {
        color: #656565;
        font-size: 12px;
        line-height: 17px;
    }
    /* 基础字段样式 */
    .baseField {

    }

    .inline{
        display: inline-grid;
    }

    ::v-deep .el-collapse-item__header {
        border-radius: 3px;
        height: 40px;
        line-height: 40px;
    }
    ::v-deep .cell .el-button {
        padding: 0;
    }
    /*::v-deep */
    .el-select-dropdown__item {
        height: 50px;
        line-height: 50px;
    }
    ::v-deep .el-collapse-item__header {
        /*background-color: rgba(131, 99, 182, 0.81);*/
        /*color: white;*/
    }
    ::v-deep .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content {
        color: #1c7cff;
        font-weight: bolder;
    }
    .el-select-dropdown__item.selected {
        background-color: rgba(122, 122, 122, 0.15);
    }

    .sjj_field_manger_item {
        width: 150px;
        transform: translateY(25%);
    }

    ::v-deep .sjj_field_manger_item_splitLine .el-divider__text{
        font-size: 15px;
        font-weight: bold;
    }
</style>
<style>
    .myPopover {
        min-width: unset;
        padding: 2px;
        box-shadow: 0 4px 5px rgba(0, 0, 0, .3), 0 0 4px rgba(0, 0, 0, .2);
        border-radius: 0px;
    }
    .myStep-enter {
        transform: translateX(-50px);
        opacity: 0;
    }
    .myStep-enter-active{
        transition: all 0.8s ease-in-out;
    }
    .myStep-enter-to {
        transform: translateX(0px);
        opacity: 1;
    }
    .myStep-leave {
        opacity: 0;
    }
    .myStep-leave-active {
        transition: all;
    }
    .myStep-leave-to {
        opacity: 0;
    }
</style>
